import * as React from "react";

// importing material UI components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import BeachAccessIcon from '@mui/icons-material/BeachAccess';

import logo from '../asset/adventist-fr--white.png';

export default function Header(props) {
return (
	<AppBar position="static" color='turquoise' elevation={4}>
		<Toolbar>
		{/*Inside the IconButton, we
		can render various icons*/}
		<IconButton
			size="large"
			edge="start"
			color="inherit"
			aria-label="menu"
			sx={{ mr: 2 }}
            href='/dashboard'
		>
			{/*This is a simple Menu
			Icon wrapped in Icon */}
			<BeachAccessIcon fontSize="large" />
		</IconButton>
		{/* The Typography component applies
		default font weights and sizes */}

		<Typography variant="h6"
			component="div" sx={{ flexGrow: 1, textAlign:'center', fontSize:24 }}>
			{props.title}
		</Typography>
		<img src={logo} alt={'logo église adventiste'} style={{height:50}} loading="lazy" />
		</Toolbar>
	</AppBar>
);
}
